import { type MutationHookOptions, useMutation } from "@apollo/client";
import { DeletePlatformPagesMutation } from "../graphql/mutations";
import type { DeletePlatformPagesMutationType } from "@/types/graphql/partner.generated";

export const useDeletePlatformPagesMutation = (
  options?: MutationHookOptions<DeletePlatformPagesMutationType>
) => {
  return useMutation<DeletePlatformPagesMutationType>(
    DeletePlatformPagesMutation,
    options
  );
};
